import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "children", "htmlFor", "id", "visuallyHidden", "sx"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React__default from 'react';
import InputLabel from '../internal/components/InputLabel.js';
import { useFormControlContext } from './_FormControlContext.js';
var FormControlLabel = function FormControlLabel(_ref) {
  var as = _ref.as,
    children = _ref.children,
    htmlFor = _ref.htmlFor,
    id = _ref.id,
    visuallyHidden = _ref.visuallyHidden,
    sx = _ref.sx,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useFormControlContex = useFormControlContext(),
    disabled = _useFormControlContex.disabled,
    formControlId = _useFormControlContex.id,
    required = _useFormControlContex.required;

  /**
   * Ensure we can pass through props correctly, since legend/span accept no defined 'htmlFor'
   */
  var labelProps = as === 'legend' || as === 'span' ? _objectSpread({
    as: as,
    id: id,
    visuallyHidden: visuallyHidden,
    required: required,
    disabled: disabled,
    sx: sx
  }, props) : _objectSpread({
    as: as,
    id: id,
    visuallyHidden: visuallyHidden,
    htmlFor: htmlFor || formControlId,
    required: required,
    disabled: disabled,
    sx: sx
  }, props);
  return /*#__PURE__*/React__default.createElement(InputLabel, labelProps, children);
};
FormControlLabel.displayName = "FormControlLabel";
var FormControlLabel$1 = FormControlLabel;
export { FormControlLabel$1 as default };